import { SVGProps, Ref, forwardRef } from 'react';

export const ImageOutlinedSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <g>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11.78 6.249c-.339.406-.844.616-1.45.616-.605 0-1.11-.21-1.448-.616-.32-.384-.418-.855-.418-1.25 0-.396.098-.867.418-1.25.338-.407.843-.617 1.449-.617.605 0 1.11.21 1.449.617.32.383.417.854.417 1.25 0 .395-.097.866-.417 1.25m-1.076-.897c.045-.053.093-.166.093-.353 0-.188-.048-.3-.093-.354-.026-.031-.104-.113-.373-.113-.27 0-.348.082-.374.113-.044.053-.093.166-.093.354s.049.3.093.353c.026.032.105.113.374.113s.347-.081.373-.113"
                    fill="currentColor"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8 .5C1.438.5.5 1.438.5 8s.938 7.5 7.5 7.5 7.5-.937 7.5-7.5S14.563.5 8 .5M2.125 4.319C1.96 5.192 1.9 6.37 1.9 8c0 .782.014 1.46.047 2.05l3.618-2.948 3.645 2.86 2.436-1.915 2.408 1.989c.032-.587.046-1.26.046-2.036 0-1.63-.06-2.808-.225-3.681-.162-.86-.4-1.287-.654-1.54-.253-.253-.68-.492-1.54-.654C10.808 1.96 9.63 1.9 8 1.9s-2.808.06-3.681.225c-.86.162-1.287.4-1.54.654-.253.253-.492.68-.654 1.54M13.872 11.7l-2.248-1.856-2.413 1.897-3.63-2.848-3.451 2.813c.162.843.398 1.263.649 1.514.253.253.68.492 1.54.654.873.165 2.051.225 3.681.225s2.808-.06 3.681-.225c.86-.162 1.287-.4 1.54-.654.252-.252.489-.673.65-1.52"
                    fill="currentColor"
                />
            </g>
        </g>
    </svg>
));
ImageOutlinedSize16Glyph.displayName = 'ImageOutlinedSize16Glyph';
